class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimer = null;

    // Only enable hover on desktop (matches Dawn's 990px breakpoint)
    this.mql = window.matchMedia('(min-width: 990px)');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    if (!this.mql.matches) return; // desktop only
    if (this.closeTimer) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
    }
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.mql.matches) return; // desktop only
    this.closeTimer = setTimeout(() => {
      this.close();
    }, 250); // delay so the menu doesn't snap shut
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

// ===== Hover for nested submenu flyouts (e.g. "Shop By Color") =====
document.addEventListener('DOMContentLoaded', () => {
  const mql = window.matchMedia('(min-width: 990px)');

  // Nested <details> live inside a .header__submenu (the dropdown panel)
  document.querySelectorAll('.header__submenu details').forEach((flyout) => {
    let timer = null;
    const summary = flyout.querySelector('summary');

    flyout.addEventListener('mouseenter', () => {
      if (!mql.matches) return;
      if (timer) { clearTimeout(timer); timer = null; }
      flyout.setAttribute('open', '');
      if (summary) summary.setAttribute('aria-expanded', true);
    });

    flyout.addEventListener('mouseleave', () => {
      if (!mql.matches) return;
      timer = setTimeout(() => {
        flyout.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', false);
      }, 250);
    });
  });

  // When the whole Nails dropdown closes, reset any open flyouts inside it
  document.querySelectorAll('header-menu').forEach((menu) => {
    const topDetails = menu.querySelector('details');
    if (!topDetails) return;
    topDetails.addEventListener('toggle', () => {
      if (!topDetails.open) {
        menu.querySelectorAll('.header__submenu details[open]').forEach((f) => {
          f.removeAttribute('open');
          const s = f.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', false);
        });
      }
    });
  });
});
